import firebase from "firebase/compat/app";
import formatChallengeData from "../utils/formatChallengeData";
import getUserInfoByUserId from "../data/getUserInfoByUserId";

const getChallengeList = async function(ownerId) {
  let db = firebase.firestore();

  let challengeOwnerSnapshot = [];
  let challengeAdminSnapshot = [];
  if (ownerId != undefined) {
    challengeOwnerSnapshot = await db
      .collection("wellness_competition")
      .where("owner", "==", ownerId)
      .get();
    challengeAdminSnapshot = await db
      .collection("wellness_competition")
      .where("admin", "array-contains", ownerId)
      .get();
  } else {
    challengeAdminSnapshot = await db.collection("wellness_competition").get();
  }

  const itemList = [];
  let itemKeyExist = [];
  challengeOwnerSnapshot.forEach(async (doc) => {
    let challengeList = formatChallengeData(doc.id, doc.data());
    if (challengeList.owner != undefined) {
      const userInfo = await getUserInfoByUserId(challengeList.owner);
      challengeList.admin = userInfo;
    }
    if (!itemKeyExist[doc.id]) {
      itemKeyExist[doc.id] = 1;
      itemList.push(challengeList);
    }
  });

  challengeAdminSnapshot.forEach(async (doc) => {
    let challengeList = formatChallengeData(doc.id, doc.data());
    if (challengeList.owner != undefined) {
      const userInfo = await getUserInfoByUserId(challengeList.owner);
      challengeList.admin = userInfo;
    }
    if (!itemKeyExist[doc.id]) {
      itemKeyExist[doc.id] = 1;
      itemList.push(challengeList);
    }
  });

  return itemList;
};

export default getChallengeList;
